import BossModel from "@/models/BossModel";

export default class PublicImage extends BossModel {

    /**
     * @type {string}
     */
    static apiUrl = 'public-image';

    /**
     * @type {string}
     */
    static entity = 'publicImages';

    static fields() {
        return {
            id: this.number(null).nullable(),
            path: this.attr(null),
            filename: this.attr(null),
            width: this.number(null).nullable(),
            height: this.number(null).nullable(),
            size: this.attr(null),
            compression:  this.number(null).nullable(),
            crop_left: this.number(null).nullable(),
            crop_top: this.number(null).nullable(),
            crop_width: this.number(null).nullable(),
            crop_height: this.number(null).nullable(),
            media_library_item_image_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            alt: this.attr(null),
            sizes: this.attr(null),
            available_images: this.attr(null),
            url: this.attr(null),
        }
    }

    findAvailableImage(width) {
        if (!this.available_images) {
            return null;
        }
        const foundImage = this.available_images.find(image => image.width === width);

        if (foundImage) {
            return foundImage.src;
        }

        return this.url;
    }
}
